const PaymentRoutes = '/payment';

const CartController = `${PaymentRoutes}/cart`;
const OrderController = `${PaymentRoutes}/order`;
const CouponController = `${PaymentRoutes}/coupon`;

export const PaymentService = {
    Cart: {
        GetCart: CartController,
        Update: `${CartController}/update`,
        AddToCart: `${CartController}/add-to-cart`,
        RemoveFromCart: `${CartController}/remove-from-cart`
    },
    Order: {
        AddOrder: `${OrderController}/create`,
        GetOrders: `${OrderController}s`,
        GetOrdersHistory: `${OrderController}/history`,
        GetCoursesDropDown: `${OrderController}/courses-drop-down`,
        GetStudentsDropDown: `${OrderController}/student-drop-down`

    },
    Coupon: {
        ValidateCoupon: `${CouponController}/validate`,
    },
}